// Avoid `console` errors in browsers that lack a console.
(function() {
	var method;
	var noop = function () {};
	var methods = [
		'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
		'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
		'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
		'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
	];
	var length = methods.length;
	var console = (window.console = window.console || {});

	while (length--) {
		method = methods[length];

		// Only stub undefined methods.
		if (!console[method]) {
			console[method] = noop;
		}
	}

}());

// TODO refactor things out to plugins, and more the define() requirements to the plugins
define([
	'require',
	'jquery',
	'foundation.core',
	'domReady',
	'handlebars-loader',
	'shared.main.plugins',
	'shared.main.resize',
	'shared.main.scroll',
	'foundation.reveal',
	'shared.user.feature.detection',
	'modernizr',
	'jquery-mobile-events'
], function (require, $, foundationcore, domReady, handlebars, pluginLoader) {
		// Display the build information
		require(['shared.build-info']);

		// Recalculate layouts on window resize
		$('window').on('resize',function() {
			main.update();
		});

		// Initialize Font Face Observer
		if(typeof(WCS_CONFIG) !== 'undefined' && WCS_CONFIG.get('global::fontsDeferredLoadingEnabled')){
			require(['shared.deferred-fonts-loader'],function(deferedFontsLoader) {
				$(document).fontLoader();
			});
		}

		//
		// DOM READY
		//
		domReady(function(){
			// Set user state visibility classes
			require(['shared.user']);

			// Initialize Foundation
			$(document).foundation();

			// Bind the plugin loader
			main.pluginLoader = pluginLoader;

			// Initialize everything else
			main.init();
		});
	}
);


window.main = window.main || {};
(function(obj) {
	for(var i in obj)
		window.main[i] = obj[i];
})({

	/***
	* main.update() is used to trigger page-wide redraw events
	*
	* It should be used sparingly for performance reasons
	*
	***/
	update: function (event) {

		// Fire picturefill for IE browsers VFDP-3490
		if(!window.HTMLPictureElement) {
			require(['picturefill'], function() {
				window.picturefill();
			});
		}

	},

	/****
	* Initialize page elements included from WCS like sidebar (minicart), and quickshop buttons
	****/
	initWCS: function() {
		var self = this;

		// Top Nav
		var $masterHeader = $("#master-header");
		if($masterHeader.length > 0 && typeof(WCS_CONFIG) !== 'undefined') {
            // Pages with top nav, but not accordion use legacy Foundation TopBar for Slider
            require([
                'foundation.legacy.topbar',
                'wcs.topbar-core',
                'wcs.topbar-slider'
            ], function () {
                $(document).foundationLegacy();
                $masterHeader.topbarCore().topbarSlider();
            });
        }


		// Initialize topbar search if the markup is on the page
		self.pluginLoader.loadPlugins({
			name: 'wcs.topbar-search',
			selector: '.topbar-search-form-js',
			initFunction: 'topbarSearch'
		},{
			name: 'wcs.free-gift-loader',
			selector: '#freeGiftModal'
		});

		// Track Orders Cookie
		if (typeof(WCS_CONFIG) !== 'undefined' && WCS_CONFIG.get('global::trackOrdersMadeInStoreEnable')) {
			require(['wcs.checkout-header-cookie']);
		}

		//cart,wishlist,mini-cart,mini-wishlist quantity setup
		if ($('.nav-shoppingbag-qty-js').length > 0) {
			require(["wcs.global-nav"]);
		}

		// WCS provided minicart for (sidebar panels) and CMS-hosted Top Nav
		// do not use .topnav selector alone bc ecom nav pages have a section.topnav.topbar element
		self.pluginLoader.loadPlugins({
			name: 'wcs.mini-cart',
			selector: '.global-cart-wishlist-panels-js, div.topnav',
			initFunction: 'minicart'
		});

		// Customs add your touch module
		self.pluginLoader.loadPlugins({
			name: 'configurator-add-your-touch',
			selector: '.custom-add-your-touch',
			initFunction: 'initAddYourTouch'
		});

		//VISA CHECKOUT
		function initVisaCheckout() {
			self.pluginLoader.loadPlugins({
				name: 'wcs.visacheckout-setvalues',
				selector: '.visa-checkout-form-js',
				callback: function() { $(document).visaCheckout(); }
			});
		}

		if (typeof(WCS_CONFIG) !== 'undefined' && WCS_CONFIG.get('checkout::visaCheckoutEnabled')) {
			initVisaCheckout();
			$.pubsub('subscribe', 'MINICART_CONTENT_RENDER_COMPLETE', initVisaCheckout);
		}

		//APPLE PAY
		function initApplePay() {
			self.pluginLoader.loadPlugins({
				name: 'wcs.applepay-button',
				selector: '.apple-pay-button',
				initFunction: 'applePay'
			});
		}

		function initModalOpener() {
			var url = window.location.search;
			var paramIndex = url.indexOf("openModal");
			if (paramIndex > -1) {
				url = url.substring(paramIndex);
				if (url.indexOf('&') > -1) {
					url = url.substring(0, url.indexOf('&'));
				}
				value = url.substring(url.indexOf('=') + 1); 
				// If the param is the last one in the query param list - the hash will be present, so it needs to be removed
				if (value.indexOf('#') > -1) {
					// Stripping everything after the hash value
					value = value.split('#')[0];
				}
				if (WCS_CONFIG.MODAL_OPENER[value]) {
					require(['vfdp.modalOpener'], function(modalOpener) {
						modalOpener.init();
					});
				}
			}
		}

		if(window.ApplePaySession && typeof(WCS_CONFIG) !== 'undefined' && WCS_CONFIG.get('applePay::applePayEnabled')) {
			initApplePay();
			$.pubsub('subscribe', 'MINICART_CONTENT_RENDER_COMPLETE', initApplePay);
		}

		// WCS provided kiosk clear session buttons
		if (typeof(WCS_CONFIG) !== 'undefined' && WCS_CONFIG.get('global::enableKioskSessionButtons')) {
			require(['shared.kiosk-button']);
		}

		if (typeof(WCS_CONFIG) !== 'undefined' && WCS_CONFIG.get('global::kioskEnabled')) {
			require(['shared.kiosk']);
		}

		if($('.myaccount-signin-form').length > 0 || $('.account-registration-js').length > 0) {
			self.initSignIn($('.login-registration'));
		}

		if (typeof(WCS_CONFIG) !== 'undefined' && WCS_CONFIG.MODAL_OPENER) {
			initModalOpener();
		}
	},

	/*****
	* Initialize CMS components
	*****/
	init: function() {
		// Maintain object namespace
		var self = this;

		// Condensed load and run for VFDP plugins in the document scope
		self.pluginLoader.runVFDPPlugins($(document));

		// Set up events for plugins to load dynamically (i.e. for modals)
		self.pluginLoader.initVFDPPluginEvents();

		// Intialize remote includes from WCS
		self.initWCS();

		// Initialize Analytics
		self.initAnalytics();

		// Initialize CMS components that are safe to fire more than once
		self.initCMSComponents();

		// Initialize CMS components that are NOT safe to fire more than once
		self.initOnceCMSComponents();

		// Ensure all the layouts are recalculated
		self.update();
	},

	/****
	* List of plugins that follow the standarn initialization pattern
	* that checks for an element on the page, loads via require,
	* then runs as a JQuery plugin. This pattern ensures plugins aren't
	* loaded on pages when not necessary
	****/
	plugins: {

		/****
		* List of CMS components that are safe to be fired more than once on the page.
		****/
		reusable: [
			{
				// Article Teaser Grids show previews of content pages in a grid layout
				name: 'cms.article-teaser-grid',
				selector: 'section.article-teaser-grid',
				initFunction: 'articleTeaserGrid'
			},{
				// Carousel Component with rich-content slides
				name: 'cms.carousel-container',
				selector: 'section.carousel-container',
				initFunction: 'carouselContainer'
			},{
				// CMS Grid read/more functions
				name: 'cms.grid-readmore',
				selector: '[data-grid-readmore]',
				initFunction: 'gridReadMore'
			},{
				// Hover Captions are images that display a caption on hover
				name: 'cms.hovercaptions',
				selector: '.hover-caption',
				initFunction: 'hoverCaptions'
			},{
				// Images With Hotspots use SVG to simulate image maps
				name: 'cms.image-with-hotspots',
				selector: '.image-with-hotspot',
				initFunction: 'imageWithHotspots'
			},{
				// Article Search Results component
				name: 'cms.searchresults',
				selector: 'section.searchresults',
				initFunction: 'searchResults'
			},{
				// Accordion navigation for use in a sidebar
				// also used in a horizontal configuration
				name: 'cms.secondarynavigation',
				selector: 'nav.secondarynavigation',
				initFunction: 'secondaryNavigation'
			},{
				// Email Signup component (not the one in the footer)
				name: 'cms.signupform',
				selector: 'section.emailsignup',
				// initFunction: null - Using callback instead
				callback: function() { $('form',$('section.emailsignup')).signupForm(); }
			},{
				// Responsive carousel of product tiles
				name: 'cms.product-carousel',
				selector: 'section.product-carousel',
				initFunction: 'productCarousel'
			},{
				// Responsive grid of product tiles
				name: 'cms.productgrid',
				selector: 'section.product-grid',
				initFunction: 'productGrid'
			},{
				// Team Members is a legacy article teaser grid with filters
				name: 'cms.teammembers',
				selector: 'section.teammembers',
				initFunction: 'teamMembers'
			},{
				// A recaptcha instance using wcs's key
				name: 'cms.integrate-wcs-recaptcha',
				selector: '.integrate-wcs-recaptcha',
				initFunction: 'integrateWcsRecaptcha'
			}, {
				// Bloomreach Product Compare
				name: 'bloomreach-product-compare',
				selector: '.br_search_widget',
				initFunction: 'bloomreachProductCompare'
			}, {
				name: 'foundation.accordion',
				selector: '.accordion[data-accordion]',
				callback: function($el) { $el.foundation(); }
			}, {
				name: 'foundation.equalizer',
				selector: '[data-equalizer]',
				callback: function($el) {
					// Initialize Foundation on the matching elements
					$el.foundation();
					// https://foundation.zurb.com/sites/docs/media-queries.html#javascript
					// Add the breakpoint listener to reinit foundation
					$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
						// Loop over each equalizer element to see if it's initialized
						$('[data-equalizer]').each(function(index, el) {
							var $el = $(el);
							var plugin = $el.data('zfPlugin');
							// Check if it's an Equalizer plugin
							if(!plugin || !(plugin instanceof Foundation.Equalizer)) {
								// Initialize it if not
								new Foundation.Equalizer($el);
							} else {
								// Reinit if it is
								Foundation.reInit($el);
							}
						});
					});
				}
			}, {
				name: 'wcs.loyalty-program',
				selector: '#loyalty-container',
				initFunction: 'init'
			}, {
				name: 'foundation.tooltip',
				selector: '[data-tooltip]',
				callback: function($el) { $el.foundation(); }
			}
		],

		/****
		* List of plugins that can only be safely initialized once
		*
		* //TODO: Any component in this list should be investigated
		* and probably refactored so it can live in the safe list
		* instead.
		*/
		once: [
			{
				// Article Read More provides read more behavior on 2-column templates
				// since it's not a component, it is never suitable for use in a modal or ajax loads
				name: 'cms.article-readmore',
				selector: '.cd-read-more',
				initFunction: 'articleReadMore'
			},{
				// Dynamic Media Banners is the legacy banner carousel component
				// has old vidoe implementation and a lot of crap that needs to be killed
				name: 'cms.dynamicmediabanner',
				selector: 'section.dynamicmediabanner',
				initFunction: 'dynamicMediaBanner'
			},{
				// Where2GetIt (now Brandify) is a 3rd party mapping service loaded through iframes
				name: 'shared.wheretogetit',
				selector: 'section.where2getit',
				// initFunction: null - Self-initializing so no function call needed
			},{
				name: 'foundation.core',
				selector: 'a[data-close]',
				callback:  function($el) {
			        $el.on('click', function(event) {
			            event.preventDefault();
			        });
			    }
			}
		],

		forms: [
			{
				// Form Validation using Foundation Abide
				name: 'foundation.abide',
				selector: 'form[data-abide]',
				//initFunction: null, // Use callback with an anonymous function instead
				callback: function($elements) {
					// Because Foundation Abide removes all event listeners
					// from a form when initializing we need limit initialization
					// to only forms that are NOT already initialized
					$elements.each(function() {
						var $el = $(this),
							plugin = $el.data('zfPlugin');
						// Check if this form is already initialized and as Abide form
						if(!plugin || !(plugin instanceof Foundation.Abide))
							new Foundation.Abide($el);
					});
				}
			}
		]
	},

	/****
	* Initialize CMS Components
	*
	* Initializes all CMS content components
	* that are safe to be fired more than once
	* on the page. This is necessary so we can
	* fire the components on page load, or when
	* added to the page via AJAX contents in modals
	*
	* Each component also has its own initialization
	* method so that they can be individually initalized
	* using main.initMyComponent();
	*
	* This allows us to fire them individually on-save
	* without refreshing the entire page during CMS
	* content authoring.
	****/
	initCMSComponents: function() {
		var self = this;

		// Init plugins that follow the standard pattern
		self.pluginLoader.loadPlugins(self.plugins.reusable);

		// Init plugins for standard form components
		self.initForms();
	},

	/****
	* Initialize CMS Components
	*
	* Initializes remaining page components, normally
	* only once on this load. Components in this
	* list are probably not safe to include in modals.
	*
	* //TODO: Any component in this list should be investigated
	* and probably refactored so it can live in the safe list
	* instead.
	****/
	initOnceCMSComponents: function() {
		var self = this;

		// Init plugins that follow the standard pattern
		self.pluginLoader.loadPlugins(self.plugins.once);

		// Stuff that needs non-standard intialization
		// TODO: these should be refactored into the standard pattern
		self.initImageWithOverlay();
		self.initModals(); // Recursive modals? No!
		self.initAttraqt();
		self.instantPage();
	},

	/*****
	* Initialize Analytics integrations
	*****/
	initAnalytics: function() {
		// DataLayer is the common object used for publishing
		// data for Analytics packages to subscribe to
		require(["datalayer.global"],function(){});
	},


	/*****
	* Initialize Article Teaser Grids
	*****/
	initArticleTeaserGrids: function() {
		var self = this;
		self.pluginLoader.loadPlugins(self.plugins.reusable.filter(function(el) {
			return el.name === 'cms.article-teaser-grid';
		}));
	},

	/*****
	* Initialize carousels
	*****/
	initCarouselContainers: function() {
		var self = this;
		self.pluginLoader.loadPlugins(self.plugins.reusable.filter(function(el) {
			return el.name === 'cms.carousel-container';
		}));
	},

	/*****
	* Initialize forms
	*****/
	initForms: function() {
		var self = this;
		// Initialize forms
		self.pluginLoader.loadPlugins(self.plugins.forms);
	},

	/*****
	* Initializes show more/less on grid components
	*
	* //TODO: this should replace most individual component behaviors
	*****/
	initGridReadMore: function() {
		var self = this;
		self.pluginLoader.loadPlugins(self.plugins.reusable.filter(function(el) {
			return el.name === 'cms.grid-readmore';
		}));
	},

	/*****
	* Initialize images with captions on hover
	*****/
	initHoverCaptions: function() {
		var self = this;
		self.pluginLoader.loadPlugins(self.plugins.reusable.filter(function(el) {
			return el.name === 'cms.hovercaptions';
		}));
	},

	/*****
	* Initialize Image with Overlay
	*****/
	initImageWithOverlay: function() {
		var imagewithoverlay = $('.image-with-overlay-wrapper');
		if(imagewithoverlay.length > 0) {
			require(['datalayer.cms.imagewithoverlay'],function(util) {
				imagewithoverlay.imageWithOverlayDatalayer();
			});
		}
	},

	/*****
	* Initialize responsive images with hotspots
	*****/
	initImagesWithHotspots: function() {
		var self = this;
		self.pluginLoader.loadPlugins(self.plugins.reusable.filter(function(el) {
			return el.name === 'cms.image-with-hotspots';
		}));
	},

	/*****
	* Initialize CMS Modal components using Foundation reveal
	*****/
	initModals: function() {
		// load shared reveal plugin
		require(['vfdp.reveal']);

		// When a modal is opened, initialize components
		// that are safe to reinialize so that the modal
		// contents can be used
		$(document).on('open.zf.reveal', function(e) {
			main.initCMSComponents();
			main.update();
		});
	},

	/*****
	* Initializes product carousels
	*****/
	initProductCarousels: function() {
		var self = this;
		self.pluginLoader.loadPlugins(self.plugins.reusable.filter(function(el) {
			return el.name === 'cms.product-carousel';
		}));
	},

	/*****
	* Initialize Product Grid
	*****/
	initProductGrid: function() {
		var self = this;
		self.pluginLoader.loadPlugins(self.plugins.reusable.filter(function(el) {
			return el.name === 'cms.productgrid';
		}));
	},

	/*****
	* Initialize Search Results
	*****/
	initSearchResults: function() {
		var self = this;
		self.pluginLoader.loadPlugins(self.plugins.reusable.filter(function(el) {
			return el.name === 'cms.searchresults';
		}));
	},

	/*****
	* Initializes sidebar accordion navigation
	*****/
	initSecondaryNavigations: function() {
		var self = this;
		self.pluginLoader.loadPlugins(self.plugins.reusable.filter(function(el) {
			return el.name === 'cms.secondarynavigation';
		}));
	},

	/*****
	* Initializes email signup form component
	* (not footer, that's triggered via footer.js)
	*****/
	initSignupForms: function() {
		var self = this;
		self.pluginLoader.loadPlugins(self.plugins.reusable.filter(function(el) {
			return el.name === 'cms.signupform';
		}));
	},

	/*****
	* Initialize Team Members
	*****/
	initTeamMembers: function() {
		var self = this;
		self.pluginLoader.loadPlugins(self.plugins.reusable.filter(function(el) {
			return el.name === 'cms.teammembers';
		}));
	},

	/*****
	* Attraqt
	*****/
	initAttraqt: function() {
		if( typeof(WCS_CONFIG) !== 'undefined' && WCS_CONFIG.get('ATTRAQT::ENABLED') ) {
			require([ 'wcs.attraqt', WCS_CONFIG.get('ATTRAQT::MAINJS') ], function(attraqt) {
				attraqt.init();
			});
		}
	},

	instantPage: function() {
		if( typeof(WCS_CONFIG) !== 'undefined' && WCS_CONFIG.get('global::instantPageEnabled') ) {
			require(['instant.page']);
		}
	},

	/*****
	 * Initialize sign in functionality
	 *****/
	initSignIn: function($el) {
		require(["wcs.logon-register-view"], function(LogonRegisterView) {
			$el.LogonRegisterView();
		});
	}

});
